var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"update-module"}},[(_vm.template)?_c('create-template-form',{attrs:{"template":_vm.template,"submit":_vm.changeTemplate}}):_c('a-result',{attrs:{"status":"warning","title":"The template is not editable"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }